import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import theme from "../theme/theme1";

const VisionMissionAnnouncements = () => {
  const leftCircleRef = useRef(null);
  const rightCircleRef = useRef(null);

  useEffect(() => {
    const animateCircles = () => {
      const leftCircles =
        leftCircleRef.current.querySelectorAll(".floating-circle");
      const rightCircles =
        rightCircleRef.current.querySelectorAll(".floating-circle");
      const timestamp = Date.now() / 1000;

      leftCircles.forEach((circle, i) => {
        const offset = Math.sin(timestamp + i) * 10;
        circle.style.transform = `translateY(${offset}px)`;
      });

      rightCircles.forEach((circle, i) => {
        const offset = Math.cos(timestamp + i) * 10;
        circle.style.transform = `translateY(${offset}px)`;
      });
    };

    const interval = setInterval(animateCircles, 20);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="relative flex flex-col items-center p-8 bg-white shadow-lg rounded-lg max-w-10xl mx-auto mt-8 overflow-hidden"
      style={{ fontFamily: theme.visionMissionSection.fontFamily }}
    >
      {/* Section Heading */}
      <motion.h1
        className="text-4xl font-bold mb-8"
        style={{ color: theme.visionMissionSection.headingTextColor }}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        OUR <span style={{ color: theme.visionMissionSection.borderColor }}>VISION & MISSION</span>
      </motion.h1>

      {/* Floating Circles */}
      <div
        ref={leftCircleRef}
        className="absolute -left-20 top-0 h-full flex flex-col space-y-10 items-center"
      >
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className="floating-circle bg-[#b5a262] opacity-70 rounded-full w-12 h-12 shadow-md transition duration-200"
          ></div>
        ))}
      </div>
      <div
        ref={rightCircleRef}
        className="absolute -right-20 top-0 h-full flex flex-col space-y-10 items-center"
      >
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className="floating-circle bg-[#13294b] opacity-70 rounded-full w-12 h-12 shadow-md transition duration-200"
          ></div>
        ))}
      </div>

      {/* Vision and Mission */}
      <motion.div
        className="flex flex-col md:flex-row gap-8 items-stretch w-full"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {/* Vision */}
        <div className="md:w-1/2 space-y-4 p-6 border-2 border-gray-200 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold" style={{ color: theme.visionMissionSection.headingTextColor }}>
            OUR <span style={{ color: theme.visionMissionSection.borderColor }}>VISION</span>
          </h2>
          <div
            className="border-t-4 mb-4"
            style={{ borderColor: theme.visionMissionSection.borderColor }}
          ></div>
          <p className="text-gray-700 leading-relaxed">
            To create a nurturing environment where every student is empowered to achieve their full potential, fostering a lifelong love for learning and a deep sense of community.
          </p>
          <p className="text-gray-700 leading-relaxed">
            To be a beacon of educational excellence, setting the standard for innovative teaching methods and holistic development.
          </p>
          <button
            className="mt-4 px-6 py-3 rounded-lg font-medium shadow-lg hover:shadow-xl transition-all"
            style={{
              backgroundColor: theme.visionMissionSection.buttonBackground,
              color: theme.visionMissionSection.buttonText,
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor =
                theme.visionMissionSection.buttonHoverBackground;
              e.currentTarget.style.color =
                theme.visionMissionSection.buttonHoverText;
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor =
                theme.visionMissionSection.buttonBackground;
              e.currentTarget.style.color =
                theme.visionMissionSection.buttonText;
            }}
          >
            Learn More
          </button>
        </div>

        {/* Mission */}
        <div className="md:w-1/2 space-y-4 p-6 border-2 border-gray-200 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold" style={{ color: theme.visionMissionSection.headingTextColor }}>
            OUR <span style={{ color: theme.visionMissionSection.borderColor }}>MISSION</span>
          </h2>
          <div
            className="border-t-4 mb-4"
            style={{ borderColor: theme.visionMissionSection.borderColor }}
          ></div>
          <p className="text-gray-700 leading-relaxed">
            To provide a comprehensive and inclusive education that prepares students for the challenges of the future, emphasizing critical thinking, creativity, and ethical values.
          </p>
          <p className="text-gray-700 leading-relaxed">
            To build a supportive community where students, parents, and educators collaborate to inspire and nurture the next generation of leaders and innovators.
          </p>
          <button
            className="mt-4 px-6 py-3 rounded-lg font-medium shadow-lg hover:shadow-xl transition-all"
            style={{
              backgroundColor: theme.visionMissionSection.buttonBackground,
              color: theme.visionMissionSection.buttonText,
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor =
                theme.visionMissionSection.buttonHoverBackground;
              e.currentTarget.style.color =
                theme.visionMissionSection.buttonHoverText;
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor =
                theme.visionMissionSection.buttonBackground;
              e.currentTarget.style.color =
                theme.visionMissionSection.buttonText;
            }}
          >
            Learn More
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default VisionMissionAnnouncements;